// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"3vkiq8bkja","name":"lexaSpeech","description":"Speech functionality for Lexa Reading app","endpoint":"https://61giavfykl.execute-api.us-east-1.amazonaws.com/Development","region":"us-east-1","paths":["/RhymesWith","/RhymesWith/123","/Stream","/Stream/123","/TextToSpeech","/TextToSpeech/123"]},{"id":"pjxrax8j9b","name":"AmiraSpeechStreamAPI","description":"","endpoint":"https://pjxrax8j9b.execute-api.us-east-1.amazonaws.com/Prod","region":"us-east-1","paths":["/stream"]}],
    'aws_cognito_identity_pool_id': 'us-east-1:97d31987-367d-40dd-9eee-cf756a4b4d65',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'lexaspeechapi-hosting-mobilehub-1085629480',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd19svf0viwztrx.cloudfront.net',
    //'aws_mobile_analytics_app_id': '413bdbc4d708495a84646e7cc743f24f',
    //'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'ab4ef4b4-1e57-4437-b677-d6333e2e276f',
    'aws_project_name': 'lexa-speech-api',
    'aws_project_region': 'us-east-1',
    'aws_resource_bucket_name': 'lexaspeechapi-deployments-mobilehub-1085629480',
    'aws_resource_name_prefix': 'lexaspeechapi-mobilehub-1085629480',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'lexaspeechapi-userfiles-mobilehub-1085629480',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_N2qYJf68Y',
    'aws_user_pools_web_client_id': '7sq870peb6a89ibhedcociti6',
    'aws_appsync_graphqlEndpoint': 'https://4tsmcay4pnbhtmpxq7o24wktgy.appsync-api.us-east-1.amazonaws.com/graphql',
    'aws_appsync_region': 'us-east-1',
    'aws_appsync_authenticationType': 'API_KEY',
    'aws_appsync_apiKey': 'da2-6bolf4d5sfbdzmulnjazxmjuza',
}

export default awsmobile;
